var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseGeneralComments',{key:_vm.versionkeyreload,attrs:{"GeneralComments":_vm.payload,"entrycode":_vm.entrycode,"passed":true}})}
var staticRenderFns = []

export { render, staticRenderFns }